export class ModelTaskModel {
  id: number;
  description: string;
  keyword: string;
  criteria: string;
  measure: boolean | null;
  measure_type: 'value' | 'text' | 'photo' | null;
  duration: number;
  component: string;

  state: string;
  stateId: number;
  frequency: string;
  frequencyId: number;
  trade: string;
  tradeId: number;
  activity: string;
  activityId: number;
  tools: string;
  toolIds: number[];
  criticalityIds: number[];
  model: string;
  modelId: number;
  procedure: string;
  comment: string;
  justification: string;
  procedure_text: string;
  procedure_pdf_original_name: string | null;

  constructor(data: any) {
    this.id = data.id ? data.id : 0;

    this.description = data.description ? data.description : '';
    this.keyword = data.keyword ? data.keyword : '';
    this.criteria = data.criteria ? data.criteria : '';
    this.measure = typeof data.measure === 'boolean' ? data.measure : null;
    this.measure_type = data.measure_type ? data.measure_type : this.measure ? 'value' : null;
    this.duration = data.duration ? parseFloat(data.duration) : 0;
    this.component = data.component ? data.component : '';

    this.state = data.state ? data.state : null;
    this.stateId = data.stateId ? data.stateId : null;
    this.frequency = data.frequency ? data.frequency : null;
    this.frequencyId = data.frequencyId ? data.frequencyId : null;
    this.trade = data.trade ? data.trade : null;
    this.tradeId = data.tradeId ? data.tradeId : null;
    this.activity = data.activity ? data.activity : null;
    this.activityId = data.activityId ? data.activityId : null;
    this.tools = data.tools ? data.tools : '';
    this.toolIds = data.toolIds ? data.toolIds : [];
    this.criticalityIds = data.criticalityIds ? data.criticalityIds : [];

    this.model = data.model ? data.model : '';
    this.modelId = data.modelId ? data.modelId : null;
    this.procedure = data.procedure ? data.procedure : '';
    this.comment = data.comment ? data.comment : '';
    this.justification = data.justification ? data.justification : '';
    this.procedure_text = data.procedure_text ? data.procedure_text : '';
    this.procedure_pdf_original_name = data.procedure_pdf_original_name ?? null;
  }
}
